<template>
  <v-container class="signup-container">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <v-row justify="center">
          <v-col class="d-flex flex-column" cols="12" sm="6">
            <div class="text-h5 font-weight-bold primary--text">
              {{ $t('password.title') }}
            </div>
            <div class="desc-box text-subtitle-2">
              <span>{{ $t('password.desc1') }}</span>
              <span>{{ $t('password.desc2') }}</span>
            </div>
            <span class="text-subtitle-2 font-weight-bold">{{
              $t('password.password')
            }}</span>
            <validation-provider
              v-slot="{ errors }"
              name="password"
              :rules="{
                required: true,
                min: 8,
                regex: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/
              }"
            >
              <v-text-field
                type="password"
                :placeholder="$t('password.passwordPlaceholder')"
                v-model="password"
                :error-messages="errors"
                label="Password"
                clearable
              ></v-text-field>
            </validation-provider>
            <span class="text-subtitle-2 font-weight-bold">
              {{ $t('password.confirmPassword') }}
            </span>
            <validation-provider
              v-slot="{ errors }"
              name="confirm"
              rules="required|password:@password"
            >
              <v-text-field
                type="password"
                :placeholder="$t('password.passwordPlaceholder')"
                v-model="confirm"
                :error-messages="errors"
                label="Confirm Password"
                clearable
              ></v-text-field>
            </validation-provider>
            <span class="text-subtitle-2 font-weight-bold">{{
              $t('password.verificationCode')
            }}</span>
            <validation-provider
              v-slot="{ errors }"
              name="token"
              rules="required"
            >
              <v-text-field
                :placeholder="$t('password.verificationCodePlaceholder')"
                type="number"
                v-model="token"
                label="verifycode"
                :error-messages="errors"
                clearable
              ></v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <v-alert
          v-model="alert"
          type="error"
          dense
          outlined
          transition="scroll-y-transition"
          class="text-body-2 last-item"
        >
          {{ error }}
        </v-alert>
        <v-row>
          <v-col cols="6">
            <v-btn
              class="font-weight-bold"
              tile
              fixed
              x-large
              style="width:50%;z-index: 5;left: 0;bottom: 0px;height: 56px;"
              to="/signin"
            >
              {{ $t('back') }}
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              class="font-weight-bold"
              color="primary"
              tile
              fixed
              x-large
              style="width: 50%;z-index: 5;left: 50%;bottom: 0px;height: 56px;"
              type="submit"
              :disabled="loading"
            >
              {{ $t('password.submit') }}
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  </v-container>
</template>

<script>
import { required, regex, min } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from 'vee-validate'

setInteractionMode('eager')

export default {
  data: () => ({
    token: '',
    password: '',
    confirm: '',
    error: '',
    alert: false
  }),
  computed: {
    loading() {
      return this.$store.getters.loading
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    onSubmit() {
      if (this.$refs.observer.validate()) {
        this.$store.commit('loading', true)
        const params = {
          email: this.$route.params.email,
          password: this.password,
          token: this.token,
          type: 'password'
        }

        this.$store
          .dispatch('VERIFY_EMAIL', params)
          .then((res) => {
            this.$store.commit('loading', false)
            if (res.status) {
              this.$store.dispatch('toast', {
                toast: true,
                toast_msg: this.$t('password.successMessage'),
                timeout: 3000
              })
              this.$router.push('/signin')
            }

            if (res.code === 'invalid') {
              this.alert = true
              this.error = this.$t('invalidMessage')
            } else if (res.code === 'token') {
              this.alert = true
              this.error = this.$t('password.tokenMessage')
            } else {
              this.alert = true
              this.error = res.code
            }
          })
          .catch((err) => {
            this.$store.commit('loading', false)
            this.alert = true
            this.error = this.$t('errorServer')
          })
      }
    }
  },
  created() {
    extend('required', {
      ...required,
      message: this.$t('signup.requiredMessage')
    })
    extend('password', {
      params: ['target'],
      validate(value, { target }) {
        return value === target
      },
      message: this.$t('signup.passwordMessage')
    })
    extend('regex', {
      ...regex,
      message: this.$t('signup.regexMessage')
    })
    extend('min', {
      ...min,
      message: this.$t('signup.regexMessage')
    })

    if (!this.$route.params.email) this.$router.replace('/signin')
  }
}
</script>

<style>
.desc-box {
  background-color: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  margin: 1rem 0;
}
</style>
